/**
 * /* eslint-disable jsx-a11y/no-static-element-interactions
 *
 * @format
 */

/** @format */

import React from "react";
import { ThemeProvider } from "styled-components";
import { useDarkMode } from "./useDarkTheme";
import { DarkTheme, LightTheme } from "./themeColor";
import { GlobalStyles } from "./global";
import Logo from "../../assets/images/logo.png";
import LogoWhite from "../../assets/images/logowhite.png";


const Theme = () => {
	const [theme, toggleTheme] = useDarkMode("dark");

	return (
		<ThemeProvider theme={theme === "light" ? LightTheme : DarkTheme}>
			<>
				<GlobalStyles />
				<div className="theme--toggler">
					<span onClick={toggleTheme}>
						{theme === "light" ? (
							<i className="fas fa-moon"></i>
						) : (
							<i className="fas fa-lightbulb"></i>
						)}
					</span>
				</div>
			</>
		</ThemeProvider>
	);
};

export default Theme;
